import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue"
import _imports_0 from '../../assets/img/eu-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "EU",
  width: "72",
  height: "48"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "content-filter"
}
const _hoisted_3 = { class: "content-filter__container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "article__featured-wrapper" }
const _hoisted_6 = { class: "content-list-page__hero-overlay" }
const _hoisted_7 = { class: "content-list-page__hero-title" }
const _hoisted_8 = {
  key: 0,
  class: "sticky-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_Image = _resolveComponent("Image")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_banner_widget = _resolveComponent("banner-widget")!
  const _component_content_card_left_img = _resolveComponent("content-card-left-img")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_page_layout = _resolveComponent("page-layout")!

  return (!_ctx.contentList)
    ? (_openBlock(), _createBlock(_component_loader, {
        key: 0,
        id: "main-content"
      }))
    : (_openBlock(), _createBlock(_component_page_layout, {
        key: 1,
        id: "main-content",
        class: "content-list-page",
        title: _ctx.title,
        description: _ctx.description
      }, _createSlots({
        side: _withCtx(() => [
          (_ctx.showStickyBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_banner_widget, {
                  zone: { desktop: 'medium_rectangle_1_sticky' },
                  "show-background": false,
                  "label-position": "bottom"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "before"),
          (_ctx.showFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["content-filter__button", { 'selected': !_ctx.selectedFilters.length }]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectFilter(null)), ["prevent"]))
                  }, " Összes ", 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (option) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: option.value,
                      type: "button",
                      class: _normalizeClass(["content-filter__button", { 'selected': _ctx.isFilterSelected(option.value) }]),
                      onClick: _withModifiers(($event: any) => (_ctx.selectFilter(option.value)), ["prevent"])
                    }, _toDisplayString(option.label), 11, _hoisted_4))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFeatured)
            ? (_openBlock(), _createBlock(_component_nav_link, {
                key: 1,
                to: _ctx.highlightedContent.url,
                class: "content-list-page__hero"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Image, {
                      class: "article__featured",
                      "image-url": _ctx.highlightedContent.leadImageUrls?.leadImageUrl169,
                      alt: _ctx.highlightedContent.title,
                      "is-lcp": true
                    }, null, 8, ["image-url", "alt"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.highlightedContent.title), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", { contentList: _ctx.contentList }, () => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentList?.items, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (i % 3 === (_ctx.showFeatured ? 0 : 1))
                    ? (_openBlock(), _createBlock(_component_banner_widget, {
                        key: 0,
                        class: "content-list-page__banner",
                        zone: `dynamic_${(i + (_ctx.showFeatured ? 3 : 2)) / 3}`,
                        "label-position": "bottom"
                      }, null, 8, ["zone"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_content_card_left_img, {
                    content: item,
                    "show-title": true,
                    "show-tag": true,
                    "show-lead": true,
                    "show-image": true,
                    "show-duration": true,
                    "is-lcp": !_ctx.showFeatured && i === 0
                  }, null, 8, ["content", "is-lcp"])
                ], 64))
              }), 128))
            ])
          ]),
          _createVNode(_component_pagination, {
            page: _ctx.paginate,
            limit: _ctx.length,
            "total-count": _ctx.contentList?.totalCount,
            "page-param-name": "oldal"
          }, null, 8, ["page", "limit", "total-count"])
        ]),
        _: 2
      }, [
        (_ctx.$route?.params.tag === 'europa')
          ? {
              name: "titleicon",
              fn: _withCtx(() => [
                _hoisted_1
              ]),
              key: "0"
            }
          : (_ctx.avatar)
            ? {
                name: "titleicon",
                fn: _withCtx(() => [
                  _createVNode(_component_Image, {
                    "image-url": _ctx.avatar,
                    alt: _ctx.title,
                    class: "content-list-page__avatar"
                  }, null, 8, ["image-url", "alt"])
                ]),
                key: "1"
              }
            : undefined
      ]), 1032, ["title", "description"]))
}